module.exports = __webpack_public_path__ + "static/UNITY-Tower-lower-floor-modern_v2-en-e60ce99d108093b619b82f3ff0693a20.pdf";